class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');

    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    const hasCartItems = this.querySelector('.cart-item') || this.querySelector('[id^="CartDrawer-Item-"]');

    if (hasCartItems) {
      this.classList.remove('is-empty');

      const drawerInner = this.querySelector('.drawer__inner');
      if (drawerInner) drawerInner.classList.remove('is-empty');
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        let containerToTrapFocusOn = null;

        if (this.classList.contains('is-empty')) {
          containerToTrapFocusOn = this.querySelector('.drawer__inner-empty');
        } else {
          containerToTrapFocusOn = document.getElementById('CartDrawer');
        }

        if (!containerToTrapFocusOn) {
          containerToTrapFocusOn = this.querySelector('.drawer__inner') || this;
        }

        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close') ||
          containerToTrapFocusOn;

        if (typeof trapFocus === 'function' && containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }

    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    if (parsedState.item_count > 0) {
      this.classList.remove('is-empty');

      const drawerInner = this.querySelector('.drawer__inner');
      if (drawerInner) drawerInner.classList.remove('is-empty');
    } else {
      this.classList.add('is-empty');

      const drawerInner = this.querySelector('.drawer__inner');
      if (drawerInner) drawerInner.classList.add('is-empty');
    }

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      if (!parsedState.sections || !parsedState.sections[section.id]) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');

      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      }

      if (parsedState.item_count > 0) {
        this.classList.remove('is-empty');

        const drawerInner = this.querySelector('.drawer__inner');
        if (drawerInner) drawerInner.classList.remove('is-empty');
      }

      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const element = parsedHtml.querySelector(selector);

    return element ? element.innerHTML : html;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);